<template>
  <div class="product-review">
    <div class="commentlist">
      <h6>{{datas.length}} REVIEW FOR AENEAN EU TRISTIQUE</h6>
      <div class="single-comment" v-for="item in datas">
        <div class="single-comment-thumb">
          <img src="/img/author-image/author-image-1.png" alt="hastech logo">
        </div>
        <div class="single-comment-content">
          <div class="single-comment-content-top">
            <h6>{{item.memberNickName}} – February 17, 2015</h6>
            <div class="ratting-box">
              <span :class="{active:item.star>=1}"><i class="fa fa-star"></i></span>
              <span :class="{active:item.star>=2}"><i class="fa fa-star"></i></span>
              <span :class="{active:item.star>=3}"><i class="fa fa-star"></i></span>
              <span :class="{active:item.star>=4}"><i class="fa fa-star"></i></span>
              <span :class="{active:item.star==5}"><i class="fa fa-star"></i></span>
            </div>
          </div>
          <p>{{item.content}}</p>
        </div>
      </div>
    </div>

    <div class="commentbox mt-5">
      <h6>ADD A REVIEW</h6>
      <div class="sn-form-inner">
        <div class="single-input">
          <label>Your Rating</label>
          <div class="ratting-box hover-action">
            <span :class="{active:review.star>=1}" @click="review.star=1"><i class="fa fa-star"></i></span>
            <span :class="{active:review.star>=2}" @click="review.star=2"><i class="fa fa-star"></i></span>
            <span :class="{active:review.star>=3}" @click="review.star=3"><i class="fa fa-star"></i></span>
            <span :class="{active:review.star>=4}" @click="review.star=4"><i class="fa fa-star"></i></span>
            <span :class="{active:review.star==5}" @click="review.star=5" ><i class="fa fa-star"></i></span>
          </div>
        </div>
        <div class="single-input">
          <label for="new-review-textbox">Your Review</label>
          <textarea id="new-review-textbox" v-model="review.content" cols="30" rows="5"></textarea>
        </div>
        <div class="single-input">
          <label for="new-review-name">Name*</label>
          <input type="text" id="new-review-name" v-model="review.memberNickName">
        </div>
        <div class="single-input">
          <label for="new-review-email">Email*</label>
          <input type="email" id="new-review-email" v-model="review.eMail">
        </div>
        <div class="single-input">
          <label for="new-review-tel">Phone</label>
          <input type="email" id="new-review-tel" v-model="review.tel">
        </div>
        <div class="single-input">
          <button class="sn-button sn-button-dark" type="submit" @click="submitReview()"><span>Submit</span></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import request from '@/utils/request'
    const defaultValue = {
      star:5,
      content:'',
      eMail:'',
      memberNickName:'',
      productId:0,
      contentPath:'',
      tel:''
    }
    export default {
      name: "review",
      data(){
        return {
          review: Object.assign({}, defaultValue),
          datas:[],
          count: '',
          timer: null
        }
      },
      mounted(){
        let _this = this
        request({
          url:'/pms-comment/list',
          method:'GET',
          params:{contentPath:window.location.href}
        }).then(res=>{
          if(res.data.code===200){
            _this.datas = res.data.data
          }
        });
      },
      methods:{
        setTimer(){
          const TIME_COUNT = 4;
          if (!this.timer) {
            this.count = TIME_COUNT;
            $("#messageModal").modal("show")
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                $("#messageModal").modal("hide")
                clearInterval(this.timer);
                this.timer = null;

              }

            }, 1000)

          }

        },
        submitReview(){
          this.review.contentPath = window.location.href
          request({
            url:'/pms-comment/save',
            method:'POST',
            data:this.review
          }).then(res=>{
            this.setTimer()
            this.review =  Object.assign({}, defaultValue)
          })
        }
      }
    }
</script>

<style scoped>

</style>
